import CoreInstance from '../CoreInstance';
import { getTransformOpts } from '../adapters/transforms';
import { customActivitiesAdapter, customActivityAdapter } from '../adapters/dapAdapters';
import { localeFlag, setParam, getHeadersWithTokens } from '../ApiHelpers';

interface IUploadActivity {
  getSkillsByArea(areaId: number): any;
  getMilestonesBySkill(skillId: number): any;
  getCustomActivities(page: number, perPage: number, userId?: number): Promise<any>;
  getCommunityActivities(): Promise<any>;
  getCustomActivity(activityId: number, filters: any): Promise<any>;
  deleteCustomActivities(activityId: number): Promise<any>;
  createCustomActivity(body: any): Promise<any>;
  editCustomActivity(activityId: number, body: any): Promise<any>;
  shareCatalogCustomActivity(activityId: number, body: any): Promise<any>;
  shareDapCustomActivity(): any;
}

const customActivitiesTranOpts = getTransformOpts(customActivitiesAdapter);

const uploadActivity: IUploadActivity = {
  getSkillsByArea: (areaId) => CoreInstance.get(`/centers/areas/${areaId}/skills?${localeFlag()}`, getHeadersWithTokens(true)),
  getMilestonesBySkill: (skillId) => CoreInstance.get(`/centers/skills/${skillId}/milestones?${localeFlag()}`, getHeadersWithTokens(true)),
  getCustomActivities: (page, perPage, userId) => CoreInstance.get(`/centers/custom_activities?per_page=${perPage}&page=${page}&${localeFlag()}${setParam('user_id', userId)}`, { ...getHeadersWithTokens(true), ...customActivitiesTranOpts }),
  getCommunityActivities: () => CoreInstance.get(`/centers/custom_activities/classrooms?${localeFlag()}${setParam('permission', 'true')}`, getHeadersWithTokens(true)),
  getCustomActivity: (activityId, filters = '') => CoreInstance.get(`/centers/custom_activities/${activityId}?${filters ? `${filters}&` : ''}${localeFlag()}`, { ...getHeadersWithTokens(true), ...getTransformOpts(customActivityAdapter) }),
  deleteCustomActivities: (activityId) => CoreInstance.delete(`/centers/custom_activities/${activityId}`, getHeadersWithTokens(true)),
  createCustomActivity: (body) => CoreInstance.post('/centers/custom_activities', body, getHeadersWithTokens(true)),
  editCustomActivity: (activityId, body) => CoreInstance.put(`/centers/custom_activities/${activityId}`, body, getHeadersWithTokens(true)),
  shareCatalogCustomActivity: (activityId, body) => CoreInstance.post(`/centers/custom_activities/${activityId}/share_activity?${localeFlag()}`, body, getHeadersWithTokens(true)),
  shareDapCustomActivity: () => {},
};

export default uploadActivity;
